import React, { ReactNode } from 'react';

import cx from 'classnames';
import parse from 'html-react-parser';

import tenantCircle from '../../../../assets/images/tenantCircle.png';
import { IKImage } from '../../../IKImage';
import useStyles from './styles';

const fillRegExp = new RegExp('fill="#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})', 'g');
const strokeRegExp = new RegExp('stroke="#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})', 'g');

interface PathwayLogoProps {
  circleUrl?: string | null;
  icon?: string | null | ReactNode;
  wrapperClass?: string;
}

const PathwayLogo: React.FC<PathwayLogoProps> = ({ circleUrl, icon = '', wrapperClass }) => {
  const classes = useStyles();

  const updatedSvgContent =
    typeof icon === 'string' &&
    icon.replace(fillRegExp, 'fill="currentColor"').replace(strokeRegExp, 'stroke="currentColor"');

  return (
    <div className={cx(classes.imageWrapper, wrapperClass)}>
      {circleUrl ? (
        <IKImage data-testid="pathwayLogo" path={circleUrl} className={classes.circle} />
      ) : (
        <img data-testid="pathwayLogo" className={classes.circle} alt="logo" src={tenantCircle} />
      )}
      {updatedSvgContent ? parse(updatedSvgContent || '') : icon}
    </div>
  );
};

export default PathwayLogo;
